import script from "./SelectMaterialAssignPhaseModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectMaterialAssignPhaseModal.vue?vue&type=script&lang=ts&setup=true"

import "./SelectMaterialAssignPhaseModal.vue?vue&type=style&index=0&id=726290a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726290a2"]])

export default __exports__